import React from 'react';
import { Loader2 } from 'lucide-react';
interface ButtonProps extends React.ButtonHTMLAttributes<HTMLButtonElement> {
  variant?: 'primary' | 'secondary' | 'outline' | 'ghost' | 'link';
  size?: 'sm' | 'md' | 'lg';
  isLoading?: boolean;
  leftIcon?: React.ReactNode;
  rightIcon?: React.ReactNode;
  noGradient?: boolean;
}
export function Button({
  children,
  className = '',
  variant = 'primary',
  size = 'md',
  isLoading = false,
  leftIcon,
  rightIcon,
  disabled,
  noGradient = false,
  ...props
}: ButtonProps) {
  const baseStyles = 'inline-flex items-center justify-center rounded-md font-medium transition-all focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-primary focus-visible:ring-offset-2 disabled:opacity-50 disabled:pointer-events-none ring-offset-background';
  const variants = {
    primary: noGradient ? 'bg-gray-900 text-white hover:bg-gray-800 shadow-sm' : 'bg-gradient-to-r from-indigo-600 via-purple-600 to-pink-600 bg-[length:200%_auto] text-white hover:bg-right-center shadow-sm animate-gradient',
    secondary: noGradient ? 'bg-gray-900 text-white hover:bg-gray-800 shadow-sm' : 'bg-gradient-to-r from-indigo-600 via-purple-600 to-pink-600 bg-[length:200%_auto] text-white hover:bg-right-center shadow-sm animate-gradient',
    outline: 'border border-gray-200 bg-white hover:bg-gray-50 text-gray-900',
    ghost: 'hover:bg-gray-100 text-gray-700 hover:text-gray-900',
    link: 'text-primary underline-offset-4 hover:underline'
  };
  const sizes = {
    sm: 'h-9 px-3 text-sm',
    md: 'h-10 px-4 py-2 text-sm',
    lg: 'h-12 px-8 text-base'
  };
  return <button className={`${baseStyles} ${variants[variant]} ${sizes[size]} ${className}`} disabled={disabled || isLoading} {...props} data-id="element-205">
      {isLoading && <Loader2 className="mr-2 h-4 w-4 animate-spin" data-id="element-206" />}
      {!isLoading && leftIcon && <span className="mr-2" data-id="element-207">{leftIcon}</span>}
      {children}
      {!isLoading && rightIcon && <span className="ml-2" data-id="element-208">{rightIcon}</span>}
    </button>;
}